import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function CustomModal(props) {
    const theme = useTheme();
    const handleClose = () => {
        props.setOpen(false);
    };

    const maxWidth = props.big ? 'md' : props.medium ? 'sm' : 'xs';

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={maxWidth}
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    bgcolor: 'background.paper'
                }
            }}
        >
            {props.title && (
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        color: 'text.primary'
                    }}
                >
                    <Box 
                        component="span" 
                        sx={{ 
                            fontWeight: 600, 
                            fontSize: '1.25rem',
                            color: 'text.primary'
                        }}
                    >
                        {props.title}
                    </Box>
                    {props.showClose && (
                        <IconButton
                            onClick={handleClose}
                            size="small"
                            sx={{
                                color: 'text.secondary',
                                '&:hover': {
                                    bgcolor: 'action.hover'
                                }
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </DialogTitle>
            )}
            <DialogContent
                sx={{
                    pt: props.title ? 3 : 3,
                    pb: props.footer ? 2 : 3,
                    ...(props.className && {})
                }}
            >
                {props.children}
            </DialogContent>
            {props.footer && (
                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    <Button onClick={handleClose} variant="outlined" color="secondary">
                        Close
                    </Button>
                    <Button variant="contained" color="primary">
                        Save changes
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}

export default CustomModal;
